var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('TabView',{attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"store",fn:function(){return [_c('PerformancesWithLines',{attrs:{"role":_vm.USER_ROLES.STORE_MANAGER}})]},proxy:true},{key:"ca",fn:function(){return [_c('PerformancesWithPie',{attrs:{"role":_vm.USER_ROLES.STORE_MANAGER}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }